import api from '@pray/shared/utils/api';

export type RetryTranslationParams = {
  contentLocalizedId: string;
  mediaType: string;
};

export type RetryTranslationResponse = {
  data: {
    id: string;
    translation_status: string;
  };
};

export async function retryTranslation({
  contentLocalizedId,
  mediaType,
}: RetryTranslationParams): Promise<RetryTranslationResponse> {
  const url = `/web/studio/system-check/translations/${contentLocalizedId}/retry`;
  const response = await api.executePostRequest<RetryTranslationResponse>(url, {
    media_type: mediaType,
  });

  return response.data;
}
